var map = {
	"./Director_Image.png": 8428,
	"./about-page_banner-mob.jpg": 1551,
	"./about.png": 3987,
	"./banner-desktop.png": 9235,
	"./missionvision1.jpg": 1501,
	"./missionvision2.jpg": 5922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8072;